/**
 * @file LoadingScreen.tsx
 *
 * @description
 *
 * Loading screen to show loading bar when state isLoading or hasUpdated is true.
 * On initial fetching, no content is displayed for at least 500ms. If data hasUpdated,
 * loading screen and content is shown.
 */

/* React */
import React from "react";

/* React-Redux */
import { useSelector } from "react-redux";
import { RootState } from "src/redux/store";

/* Stylesheet */
import styles from "./LoadingScreen.module.scss";

const LoadingBarExample: React.FC = () => {
  const { isLoading, isUpdating } = useSelector(
    (state: RootState) => state.loadingScreen
  );
  return isLoading || isUpdating ? (
    <div className={styles.loading_screen}>
      <div className={styles.loading_bar} />
    </div>
  ) : undefined;
};

export default LoadingBarExample;
